export enum AnalyticsEvent {
  // official ones:
  PAGE_VIEW = 'pageview',
  ENGAGEMENT = 'engagement',
  FILE_DOWNLOAD = 'File Download',
  FORM_SUBMISSION = 'Form: Submission',
  OUTBOUND_LINK = 'Outbound Link: Click',
  // custom ones:
  CAROUSEL_INTERACTION = 'carouselInteraction',
  SWISS_BILL_QR_CODE_CARD_INTERACTION = 'swissBillQrCodeCardInteraction',
  VIDEO_PLAYED = 'VideoPlayed',
  CONTACT_FORM_SUBMIT = 'ContactFormSubmit',
  CARDS_CAROUSEL_INTERACTION = 'cardsCarouselInteraction',
  NEWSLETTER_SUBSCRIPTION_FORM_SUBMIT = 'NewsletterSubscriptionFormSubmit',
  FILTER_PUBLICATION_ITEMS = 'filterPublicationItems',
  FILTER_PROJECT_ITEMS = 'filterProjectItems',
}
